import {useTranslation} from 'react-i18next';

const Footer = () => {
    const {t} = useTranslation();

    return (
        <footer className="border-top footer text-muted">
            <div className="container">
                &copy; {new Date().getFullYear()} - {t('organization')}
            </div>
        </footer>
    );
}

export default Footer;
